<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    @keydown.esc="$emit('close')"
    @click:outside="$emit('close')"
  >
    <icon-form
      v-model="icon"
      :tags="tags"
      @close="$emit('close')"
      @saved="$emit('saved')"
      @deleted="$emit('deleted')"
    />
  </v-dialog>
</template>

<script>
import IconForm from '@/views/references/icons/components/IconForm.vue';

export default {
  name: 'icon-edit-dialog',

  components: { IconForm },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object,
      default: null,
    },
    tags: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      dialog: this.value,
    };
  },
};
</script>
